import script from "./CategoriaTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoriaTable.vue?vue&type=script&setup=true&lang=ts"

import "./CategoriaTable.vue?vue&type=style&index=0&id=41e6c2ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41e6c2ca"]])

export default __exports__